/**
 * Общие хелперы тактильной обратной связи (Telegram WebApp HapticFeedback).
 * Используются во всех игровых режимах SKINOZ.
 *
 * Если API недоступен (обычный браузер / старая версия Telegram) — функции
 * молча игнорируются и не бросают ошибок.
 *
 * Документация: https://core.telegram.org/bots/webapps#hapticfeedback
 */

const getHapticFeedback = () => {
  try {
    return window?.Telegram?.WebApp?.HapticFeedback || null
  } catch (error) {
    return null
  }
}

/**
 * Виброотклик "столкновения" UI-элементов.
 * style: 'light' | 'medium' | 'heavy' | 'rigid' | 'soft'
 */
export const hapticImpact = (style = 'light') => {
  const haptic = getHapticFeedback()
  if (!haptic || typeof haptic.impactOccurred !== 'function') return

  try {
    haptic.impactOccurred(style)
  } catch (error) {
    // Игнорируем — например, неподдерживаемый style
  }
}

/**
 * Виброотклик уведомления о результате действия.
 * type: 'success' | 'error' | 'warning'
 */
export const hapticNotify = (type = 'success') => {
  const haptic = getHapticFeedback()
  if (!haptic || typeof haptic.notificationOccurred !== 'function') return

  try {
    haptic.notificationOccurred(type)
  } catch (error) {
    // Игнорируем
  }
}

/**
 * Виброотклик при изменении выбора (для picker-подобных переключателей).
 * НЕ использовать при подтверждении/одиночном выборе — только при смене.
 */
export const hapticSelectionChanged = () => {
  const haptic = getHapticFeedback()
  if (!haptic || typeof haptic.selectionChanged !== 'function') return

  try {
    haptic.selectionChanged()
  } catch (error) {
    // Игнорируем
  }
}
